module.exports = __webpack_public_path__ + "static/media/student-login-instructions.0d98807f.pdf";